(function() {
  var DeleteDialog, Handler, Service,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Service = App.loadClass('core::Angular/Service');

  Handler = App.loadClass('core::Handler');

  DeleteDialog = App.loadClass('core::DeleteDialog');

  exports.LegacyHandlerService = (function(superClass) {
    extend(LegacyHandlerService, superClass);

    function LegacyHandlerService(rootScope, timeout, legend) {
      this.rootScope = rootScope;
      this.timeout = timeout;
      this.legend = legend;
      this.destroyAllSubHandlers = bind(this.destroyAllSubHandlers, this);
      this.destroySubHandler = bind(this.destroySubHandler, this);
      this.createSubHandler = bind(this.createSubHandler, this);
      this.createDeleteDialog = bind(this.createDeleteDialog, this);
      this.createViewDialog = bind(this.createViewDialog, this);
      this.getLegacyFilePath = bind(this.getLegacyFilePath, this);
      this.singleSubHandler = false;
      this.activeSubHandlers = {};
      this.currentDialog = '';
      this.saveUrl = '';
    }

    LegacyHandlerService.prototype.getLegacyFilePath = function(layerType) {
      switch (layerType) {
        case 'nitrogen':
          this.currentDialog = 'grower::handlers/data/layers/Layer_Nitrogen_Dialog';
          return this.saveUrl = 'backend/grower/layers/nitrogen/update';
        case 'ears_rows_length':
          this.currentDialog = 'grower::handlers/data/layers/Layer_Ears_Rows_Length_Dialog';
          return this.saveUrl = 'backend/grower/layers/ears-rows-length/update';
        case 'harvest_load':
          this.currentDialog = 'grower::handlers/data/layers/Layer_Harvest_Load_Dialog';
          return this.saveUrl = 'backend/grower/layers/harvest-load/update';
        case 'prescription_map':
          this.currentDialog = 'grower::handlers/data/layers/Layer_Prescription_Map_Dialog';
          return this.saveUrl = 'backend/grower/layers/prescription-map/update';
        case 'stand_count':
          this.currentDialog = 'grower::handlers/data/layers/Layer_Stand_Count_Dialog';
          return this.saveUrl = 'backend/grower/layers/standcount/update';
        case 'planting_rx':
          this.currentDialog = 'grower::handlers/data/layers/Layer_Planting_Rx_Visualize';
          return this.saveUrl = '';
        case 'soils':
          this.currentDialog = 'grower::handlers/data/layers/Layer_Soil';
          return this.saveUrl = '';
        case 'management_zone':
          return this.currentDialog = 'grower::handlers/data/layers/Layer_Management_Zones';
        case 'cdl':
          this.currentDialog = 'grower::handlers/data/layers/Layer_CDL';
          return this.saveUrl = '';
        case 'pad':
          this.currentDialog = 'grower::handlers/data/layers/Layer_PAD';
          return this.saveUrl = '';
        case 'shapefile':
          this.currentDialog = 'grower::handlers/data/layers/shapefile/Layer_Shapefile';
          return this.saveUrl = '';
        case 'ShapefileBinning':
          this.currentDialog = 'grower::handlers/data/layers/shapefile/Layer_Shapefile_Binning';
          return this.saveUrl = 'backend/grower/layers/shapefile/set-binning';
      }
    };

    LegacyHandlerService.prototype.createViewDialog = function(layerName, saveUrl, is_new, is_editable, row, postOps) {
      var newLayerName, view;
      if (saveUrl == null) {
        saveUrl = null;
      }
      if (row == null) {
        row = null;
      }
      if (row !== null) {
        row.rowClass = 'darken';
      }
      newLayerName = layerName + postOps.layer_id;
      if (is_new) {
        view = this.createSubHandler(layerName);
      } else {
        view = this.createSubHandler(layerName, newLayerName);
      }
      if (view) {
        view.loadLayoutPostOptions = {
          fields_id: postOps.fields_id,
          has_edit: postOps.has_edit,
          id: postOps.id,
          layer_id: postOps.layer_id,
          year: postOps.year,
          extra_data: postOps.extra_data
        };
        view.startEditing = is_new || is_editable;
        view.refreshNavHandler = false;
        if (saveUrl === null) {
          view.saveUrl = this.saveUrl;
        } else {
          view.saveUrl = saveUrl;
        }
        view.afterHidden = (function(_this) {
          return function() {
            if (view.refreshing) {
              view.refreshing = false;
              return;
            }
            view.destroy();
            return _this.rootScope.$broadcast('legacyDialog:closed', {
              layer: row
            });
          };
        })(this);
        view.successAction = (function(_this) {
          return function() {
            var changeFieldDetails;
            changeFieldDetails = 'grower::handlers/fields/dialogs/FieldDetailsDialog';
            if (_this.currentDialog === changeFieldDetails) {
              return _this.rootScope.$broadcast('layer:updated', {
                layer: null
              });
            }
          };
        })(this);
        view.init();
        return view;
      }
    };

    LegacyHandlerService.prototype.addLayer = function(layerType, postOps) {
      switch (layerType) {
        case 'Nitrogen':
          this.currentDialog = 'grower::handlers/data/layers/Layer_Nitrogen_Dialog';
          return this.createViewDialog('Nitrogen', 'backend/grower/layers/nitrogen/add', true, true, null, postOps);
        case 'Stand Count':
          this.currentDialog = 'grower::handlers/data/layers/Layer_Stand_Count_Dialog';
          return this.createViewDialog('StandCount', 'backend/grower/layers/standcount/add', true, true, null, postOps);
        case 'Ears, Rows, and Length':
          this.currentDialog = 'grower::handlers/data/layers/Layer_Ears_Rows_Length_Dialog';
          return this.createViewDialog('EarsRowsLength', 'backend/grower/layers/ears-rows-length/add', true, true, null, postOps);
        case 'Harvest Load':
          this.currentDialog = 'grower::handlers/data/layers/Layer_Harvest_Load_Dialog';
          return this.createViewDialog('HarvestLoad', 'backend/grower/layers/harvest-load/add', true, true, null, postOps);
        case 'Prescription Map':
          this.currentDialog = 'grower::handlers/data/layers/Layer_Prescription_Map_Dialog';
          return this.createViewDialog('PlantingRx', 'backend/grower/layers/planting-rx/sidebar', true, true, null, postOps);
      }
    };

    LegacyHandlerService.prototype.getDeletePath = function(layer_type) {
      switch (layer_type) {
        case 'planting':
          return this.saveUrl = 'backend/grower/layers/planting/delete';
        case 'nitrogen':
          return this.saveUrl = 'backend/grower/layers/nitrogen/delete';
        case 'fertilizer':
          return this.saveUrl = 'backend/grower/layers/fertilizer/delete';
        case 'spraying':
          return this.saveUrl = 'backend/grower/layers/spraying/delete';
        case 'stand_count':
          return this.saveUrl = 'backend/grower/layers/standcount/delete';
        case 'ears_rows_length':
          return this.saveUrl = 'backend/grower/layers/ears-rows-length/delete';
        case 'harvest_load':
          return this.saveUrl = 'backend/grower/layers/harvest-load/delete';
        case 'prescription_map':
          return this.saveUrl = 'backend/grower/layers/prescription-map/delete';
        case 'shapefile':
          return this.saveUrl = 'backend/grower/layers/shapefile/delete';
        case 'planting_rx':
          return this.saveUrl = 'backend/grower/layers/planting-rx/delete';
        case 'management_zone':
          return this.saveUrl = 'backend/grower/layers/management-zones/delete';
        case 'cover_crop':
          return this.saveUrl = 'backend/grower/layers/cover-crop/delete';
      }
    };

    LegacyHandlerService.prototype.createDeleteDialog = function(layer) {
      var del, ths;
      ths = this;
      this.getDeletePath(layer.layer_type);
      del = this.createSubHandler(DeleteDialog);
      if (del) {
        del.deleteTitle = '- ' + layer.orig_title + ' Layer';
        del.deleteMessage = 'this ' + layer.orig_title + ' Layer';
        del.deleteItemID = layer.id;
        del.saveUrl = this.saveUrl;
        del.delayAfterSuccess = true;
        del.refreshNavHandler = false;
        del.successAction = (function(_this) {
          return function() {
            return ths.rootScope.$broadcast('layer:updated', {
              layer: layer
            });
          };
        })(this);
        return del.init();
      }
    };

    LegacyHandlerService.prototype.createSubHandler = function(sub, name) {
      var handler, handlerObj, i, object, ref, ref1, ref2, ref3, v;
      if (name == null) {
        name = null;
      }
      if (this.__destroyed) {
        return null;
      }
      handler = (ref = ((ref1 = this.subHandlers) != null ? (ref2 = ref1[sub]) != null ? ref2["class"] : void 0 : void 0)) != null ? ref : sub;
      name = name != null ? name : handler;
      if (this.singleSubHandler) {
        ref3 = this.activeSubHandlers;
        for (i in ref3) {
          v = ref3[i];
          v.destroy();
        }
      } else if (this.activeSubHandlers[name] != null) {
        return false;
      }
      if (typeof handler === 'string') {
        object = window.App.loadClass(this.currentDialog);
      } else {
        object = handler;
      }
      handlerObj = new object();
      handlerObj.nameInParent = name;
      handlerObj.parent = this;
      this.activeSubHandlers[name] = handlerObj;
      return this.activeSubHandlers[name];
    };

    LegacyHandlerService.prototype.destroySubHandler = function(name, calldestroy) {
      var ref, ref1;
      if (calldestroy == null) {
        calldestroy = false;
      }
      if (((ref = this.subHandlers) != null ? ref[name] : void 0) != null) {
        name = this.subHandlers[name]["class"];
      }
      if (((ref1 = this.activeSubHandlers) != null ? ref1[name] : void 0) != null) {
        if (calldestroy) {
          return this.activeSubHandlers[name].destroy();
        } else {
          this.activeSubHandlers[name] = null;
          return delete this.activeSubHandlers[name];
        }
      }
    };

    LegacyHandlerService.prototype.destroyAllSubHandlers = function(toDestroy) {
      var j, k, layer, len, ref, results, results1, v;
      if (toDestroy == null) {
        toDestroy = null;
      }
      if (toDestroy != null) {
        results = [];
        for (j = 0, len = toDestroy.length; j < len; j++) {
          layer = toDestroy[j];
          results.push((function() {
            var ref, results1;
            ref = this.activeSubHandlers;
            results1 = [];
            for (k in ref) {
              v = ref[k];
              if (layer === k) {
                results1.push(this.destroySubHandler(k, true));
              } else {
                results1.push(void 0);
              }
            }
            return results1;
          }).call(this));
        }
        return results;
      } else {
        ref = this.activeSubHandlers;
        results1 = [];
        for (k in ref) {
          v = ref[k];
          results1.push(this.destroySubHandler(k, true));
        }
        return results1;
      }
    };

    return LegacyHandlerService;

  })(Service);

}).call(this);
